module.exports = __webpack_public_path__ + "img/item_link_ringsize.e6a4468.webp";